export const CautionIcon = ({
  height = 120,
  width = 120,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.7819 6.01614C54.2149 -2.27507 66.8533 -1.99542 71.8049 6.84957C71.9131 7.04303 71.9901 7.24724 72.0382 7.45716L119.093 91.5848L119.131 91.66C121.818 96.9059 117.936 103 112.105 103H7.86902C1.99485 103 -1.76022 96.8177 0.836781 91.6708C0.851257 91.6421 0.864525 91.6128 0.88019 91.5848L48.2773 6.84957L48.7819 6.01614ZM67.4043 8.55943C63.8639 3.14131 55.5904 3.31568 52.3577 9.08637L52.3632 9.09175L4.99318 93.7732C3.95626 95.887 5.53215 98.3758 7.86902 98.3758H112.105C114.487 98.3758 116.047 95.9051 114.98 93.7785L67.616 9.09175C67.5214 8.92268 67.453 8.74169 67.4043 8.55943Z"
        fill="#FF9500"
      />
      <path
        d="M57.5723 73.0503V29.2584C57.5723 27.9886 58.659 26.9597 60 26.9597C61.3411 26.9597 62.4278 27.9886 62.4278 29.2584V73.0503C62.4278 74.3201 61.3411 75.349 60 75.349C58.659 75.349 57.5723 74.3201 57.5723 73.0503Z"
        fill="#FF9500"
      />
      <path
        d="M60.3468 87.1008C61.8792 87.1008 63.1214 85.8628 63.1214 84.3357C63.1214 82.8085 61.8792 81.5706 60.3468 81.5706C58.8145 81.5706 57.5723 82.8085 57.5723 84.3357C57.5723 85.8628 58.8145 87.1008 60.3468 87.1008Z"
        fill="#FF9500"
      />
    </svg>
  );
};
